var ko = require('knockout'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage');

function MultipleAgenciesForUser(createAgencyEndpoint, searchAgencyEndpoint) {
  var self = this;
  var language = window.language;

  self.agencyList = ko.observableArray([]);
  self.isSearching = ko.observable(false);
  self.hasSearched = ko.observable(false);
  self.results = ko.observable();
  self.resultOption = ko.observable();

  self.init = function() {
    var chosenAgency = cart.getCart().agency;
    if (chosenAgency === undefined) {
      self.selectedAgency();
    } else if (chosenAgency.AktorId === '') {
      self.selectedAgency('select_me');
    } else if (chosenAgency.AktorId !== undefined) {
      for (var i = 0; i < self.agencyList().length; i++) {
        if (self.agencyList()[i].AktorId === chosenAgency.AktorId) {
          self.selectedAgency(self.agencyList()[i]);
          break;
        }
      }
    }
  };

  self.selectedAgency = ko.observable();
  self.selectedAgency.subscribe(function() {
    if (self.selectedAgency() !== '-1') {
      self.chooseAgency();
    }
    ko.postbox.publish('chosen_agency', self.selectedAgency());
  });
  self.chooseAgency = function() {
    var agency = self.selectedAgency();
    if (agency !== undefined) {
      if (agency === 'select_me') {
        // select_me
        $('#common-error-message').addClass('hidden');
        cart.replaceAgency({ Name: '', AktorId: '', Id: '' });
      } else if (agency === '-1') {
        // new agency
        self.createAgency();
        if (self.selectedAgency() !== '-1') {
          $('#common-error-message').addClass('hidden');
          cart.replaceAgency(self.selectedAgency());
        }
      } else {
        $('#common-error-message').addClass('hidden');
        cart.replaceAgency(agency);
      }
    }
  };

  self.createAgencyToggle = ko.observable(false);
  self.toggleAgencyPane = function() {
    self.createAgencyToggle(!self.createAgencyToggle());
  };

  self.isAddingAgency = ko.observable(false);

  self.isAlreadyMember = ko.observable(false);
  self.organizationNumber = ko.observable();
  self.searchedAgencyName = ko.observable();

  if (searchAgencyEndpoint !== undefined) {
    //Activate live searching
    self.organizationNumber.subscribe(function(orgNo) {
      if (orgNo.length == 9) {
        $.get(searchAgencyEndpoint + '?orgno=' + orgNo, function(agencyName) {
          self.searchedAgencyName(agencyName);
        });
      } else {
        self.searchedAgencyName('');
      }
    });
  }

  self.createAgency = function() {
    if (self.resultOption() !== undefined) {
      var id = self.results().AvailableAgencies[self.resultOption()].AktorId;
      if (id !== undefined) {
        self.isAddingAgency(true);
        $.post(createAgencyEndpoint, { AktorId: id })
          .success(function(response) {
            $('#common-error-message').addClass('hidden');
            if (response.CreatedAgency.AktorId !== '') {
              var chosenAgencyInAgencyList = false;
              var index = 0;
              for (var i = 0; i < self.agencyList().length; i++) {
                if (
                  self.agencyList()[i].AktorId ===
                  response.CreatedAgency.AktorId
                ) {
                  chosenAgencyInAgencyList = true;
                  index = i;
                  break;
                }
              }
              if (!chosenAgencyInAgencyList) {
                self.agencyList.push(response.CreatedAgency);
                index = self.agencyList().length - 1;
              }
              self.selectedAgency(self.agencyList()[index]);
              $('#common-error-message').addClass('hidden');
              cart.replaceAgency(self.selectedAgency());
            }
            self.resultOption(undefined);
          })
          .fail(function() {
            if (self.searchedAgencyName() !== '') {
              $('#common-error-message .error-message-text').html(
                language.memberCannotConnectToMemberAgency +
                  "<a href='" +
                  language.membershipForm +
                  "'>" +
                  language.membershipForm +
                  '</a>'
              );
            } else {
              $('#common-error-message .error-message-text').html(
                language.missingAgencyOrgNr
              );
            }
            $('#common-error-message').removeClass('hidden');
          })
          .always(function() {
            self.isAddingAgency(false);
          });
      }
    } else if (self.organizationNumber().length === 9) {
      self.isAddingAgency(true);
      $.post(createAgencyEndpoint, {
        AgencyIsMember: self.isAlreadyMember(),
        OrgNo: self.organizationNumber()
      })
        .success(function(response) {
          if (
            response.CreatedAgency === undefined ||
            response.CreatedAgency === null
          ) {
            //Multiple agencies
            self.results(response);
            self.hasSearched(true);
          } else {
            cart.replaceAgency(response.CreatedAgency);
            $('#common-error-message').addClass('hidden');
            var chosenAgencyInAgencyList = false;
            var index = 0;
            for (var i = 0; i < self.agencyList().length; i++) {
              if (
                self.agencyList()[i].AktorId === response.CreatedAgency.AktorId
              ) {
                chosenAgencyInAgencyList = true;
                index = i;
                break;
              }
            }
            if (!chosenAgencyInAgencyList) {
              self.agencyList.push(response.CreatedAgency);
              index = self.agencyList().length - 1;
            }
            self.selectedAgency(self.agencyList()[index]);
            $('#common-error-message').addClass('hidden');
            cart.replaceAgency(self.selectedAgency());
          }
        })
        .fail(function() {
          if (self.searchedAgencyName() !== '') {
            $('#common-error-message .error-message-text').html(
              language.memberCannotConnectToMemberAgency +
                "<a href='" +
                language.membershipForm +
                "'>" +
                language.membershipForm +
                '</a>'
            );
          } else {
            $('#common-error-message .error-message-text').html(
              language.missingAgencyOrgNr
            );
          }
          $('#common-error-message').removeClass('hidden');
        })
        .always(function() {
          self.isAddingAgency(false);
        });
    }
  };
}

function Model(params) {
  var self = this;

  if (
    params.createAgencyEndpoint === undefined ||
    params.agencyEndpoint === undefined
  )
    throw 'agencyEndpoint and createAgencyEndpoint must be set';

  self.states = { MultipleAgenciesForUser: 3 };

  self.currentState = ko.observable(self.states.MultipleAgenciesForUser);

  var transitions = {
    ToMultipleAgenciesForUser: function(agencyList) {
      self.multipleAgenciesForUser.agencyList(ko.unwrap(agencyList));
      self.currentState(self.states.MultipleAgenciesForUser);
    }
  };

  self.multipleAgenciesForUser = new MultipleAgenciesForUser(
    params.createAgencyEndpoint,
    params.searchAgencyEndpoint
  );

  $.getJSON(params.agencyEndpoint, function(agencies) {
    transitions.ToMultipleAgenciesForUser(agencies);
    self.multipleAgenciesForUser.init();
  });
}

module.exports = Model;
